import { useEffect } from "react";
import Reveal from "@/components/site/Reveal";
import SectionLabel from "@/components/site/SectionLabel";
import Phases from "@/components/sections/Phases";
import CTASection from "@/components/sections/CTASection";

const STEPS = [
    {
        n: "01",
        t: "Apply",
        d: "Book a free 30-minute consultation. Tell us where you are, where you've been stuck, and where you want to go.",
    },
    {
        n: "02",
        t: "Diagnose",
        d: "On the call we'll diagnose your exact blocks — mindset, skill, or lifestyle — and map the path forward.",
    },
    {
        n: "03",
        t: "Commit",
        d: "If it's a mutual fit, you commit to 90 days. We set the standard. You show up to it.",
    },
    {
        n: "04",
        t: "Execute",
        d: "Three 30-day phases. Weekly coaching. Daily reps. Real-world field work. No coasting.",
    },
    {
        n: "05",
        t: "Become",
        d: "By Day 90 you're not the same man who applied. You're calibrated, calm, and a man women naturally respect.",
    },
];

export default function HowItWorks() {
    useEffect(() => {
        document.title = "How It Works | 90 Day Alpha";
    }, []);

    return (
        <div data-testid="how-it-works-page" className="bg-[#020617]">
            <section className="relative pt-40 pb-16 md:pt-48 md:pb-24 bg-[#020617]">
                <div className="max-w-7xl mx-auto px-6 md:px-12">
                    <Reveal>
                        <SectionLabel testId="how-label">
                            The Process
                        </SectionLabel>
                        <h1 className="mt-6 font-display font-black text-white text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.98] max-w-4xl">
                            How 90 Day Alpha{" "}
                            <span className="text-[#D4AF37]">works</span>.
                        </h1>
                        <p className="mt-8 text-white/75 leading-relaxed text-base sm:text-lg max-w-2xl">
                            From application to transformation in five clear
                            stages — built for men who are tired of free advice
                            and want a structured plan that actually changes
                            them.
                        </p>
                    </Reveal>
                </div>
            </section>

            <section className="bg-[#020617] py-12 md:py-20">
                <div className="max-w-7xl mx-auto px-6 md:px-12">
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-px bg-[#142142] border border-[#142142]">
                        {STEPS.map((s, i) => (
                            <Reveal key={s.n} delay={i * 0.06}>
                                <div
                                    data-testid={`how-step-${i + 1}`}
                                    className="bg-[#020617] p-8 h-full hover:bg-[#060c1e] transition-colors border-t-2 border-transparent hover:border-[#1E90FF]"
                                >
                                    <p className="font-display font-black text-[#D4AF37] text-4xl leading-none">
                                        {s.n}
                                    </p>
                                    <h3 className="mt-6 font-display font-bold text-white text-xl tracking-tight">
                                        {s.t}
                                    </h3>
                                    <p className="mt-3 text-white/65 leading-relaxed text-sm">
                                        {s.d}
                                    </p>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            <Phases />
            <CTASection />
        </div>
    );
}
